const images = {
  icons: {
    google: require("./assets/google.svg"),
    facebook: require("./assets/facebook.svg"),
    eye: require("./assets/eye.svg"),
    eyeOff: require("./assets/eye-off.svg"),
    check: require("./assets/check.svg"),
    plus: require("./assets/plus.png"),
    prescriptionIcon: require("./assets/prescription-icon.svg"),
  },
  logo: {
    deedmed: require("./assets/logo.png"),
  },
};

export default images;
